// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';

// export const HeadOffice = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl no.', width: 70 },
//     // { id: 'name', field: 'name', headerName: 'Name', width: 250 },
//     { id: 'designation', field: 'designation', headerName: 'Designation', width: 200 },
//     { id: 'phoneNumber', field: 'phoneNumber', headerName: 'Phone Number', width: 150 },
//     { id: 'emailId', field: 'emailId', headerName: 'Email Id', width: 250 },
//   ];

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/home-notification/dep-head-offices/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           designation: item.designation,
//           phoneNumber: item.ph_number,
//           emailId: item.email,
//         }));
//         setRows(apiData);
//         setSnackbarMessage('Head Office contacts loaded successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch Head Office contacts:', error);
//         setSnackbarMessage('Failed to load Head Office contacts.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30}/>;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           Department Head Office Contacts
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';

export const HeadOffice = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('headOffice.slNo'), width: 70 },
    { id: 'designation', field: 'designation', headerName: t('headOffice.designation'), width: 200 },
    { id: 'phoneNumber', field: 'phoneNumber', headerName: t('headOffice.phoneNumber'), width: 150 },
    { id: 'emailId', field: 'emailId', headerName: t('headOffice.emailId'), width: 250 },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/home-notification/dep-head-offices/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          designation: item.designation,
          phoneNumber: item.ph_number,
          emailId: item.email,
        }));
        setRows(apiData);
        setSnackbarMessage(t('headOffice.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Head Office contacts:', error);
        setSnackbarMessage(t('headOffice.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('headOffice.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus={true}
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
